import React from 'react';

interface AuthorityGuardProps {
    children: React.ReactNode;
}
export const AuthorityGuard: React.FC<AuthorityGuardProps> = ({children}) => {
    // const location = useLocation();
    // const {session} = useSessionRedux();
    // const navigate = useNavigate();
    // const isAuthenticated = () => {
    //     return !!session.token;
    // };

    // // Only redirect if the pathname is exactly '/' and user is authenticated
    // if (location.pathname === '/' && isAuthenticated()) {
    //     navigate(appRoutes.dashboard.dashboard(), {replace: true});
    // } else if (!isAuthenticated() && authRoute.map(x => x.path.slice(0, 5)).includes(location.pathname.slice(0, 5))) {
    //     navigate(location.pathname, {replace: true});
    // } else if (!isAuthenticated()) {
    //     navigate('/login', {replace: true});
    // }

    return <>{children}</>;
};

export default AuthorityGuard;
